import { TablePaginationConfig } from 'antd'
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import WashingMethodDetailPageHeader from '@/components/pages/WashingMethods/Detail/PageHeader'
import WashingMethodDetailTable from '@/components/pages/WashingMethods/Detail/Table'
import routes from '@/constants/routes'

import { useWashingMethods } from './WashingMethod.hooks'

const WashingMethodDetail = () => {
  const navigate = useNavigate()

  const { id } = useParams()

  const {
    getWashingMethods,
    filterToQuery,
    page,
    getWashingMethodDetail,
    getWashingMethodDetailResponse,
    getWashingMethodDetailLoading,
  } = useWashingMethods()

  const handleChangePage = (config: TablePaginationConfig) => {
    navigate({
      pathname: routes.washingMethods.path,
      search: filterToQuery({
        page: config.current ?? page,
      }),
    })
  }

  useEffect(() => {
    getWashingMethods()
    getWashingMethodDetail({ id: Number(id) })
  }, [getWashingMethodDetail, getWashingMethods, id, page])

  return (
    <>
      <WashingMethodDetailPageHeader />
      <WashingMethodDetailTable
        {...{
          dataSource: getWashingMethodDetailResponse?.washingMethodDetergents,
          getWashingMethodDetailLoading,
          washingMethod: getWashingMethodDetailResponse,
          customers: getWashingMethodDetailResponse?.washingMethodCustomers,
        }}
        onChange={handleChangePage}
      />
    </>
  )
}

WashingMethodDetail.displayName = 'WashingMethodDetail'
export default WashingMethodDetail
